import { round } from "lodash";
import { format, parseISO } from "date-fns";

export default {
  date: (date?: Date | string, formatString = "yyyy-MM-dd") => {
    if (!date) return "";
    const d = typeof date === "string" ? parseISO(date) : date;
    return format(d, formatString);
  },
  number: (num?: number, precision?: number) =>
    round(num || 0, precision).toLocaleString(),
  price: (num?: number, precision?: number) =>
    `¥ ${round(num || 0, precision).toLocaleString()}`,
  percentage: (num?: number) => `${round(num || 0, 2)} %`,
};
